import { useTranslation } from "../context/TranslationContext";
import Alert from "./ds/Alert";

/** Figma's confirmation Alerts (E26–E30): a question, Cancel, and the action. */
const ConfirmModal = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmLabel,
  cancelLabel,
  isDark,
  variant = "default",
  loading = false,
}) => {
  const { t } = useTranslation();

  return (
    <Alert
      open={isOpen}
      title={title}
      message={message}
      confirmLabel={loading ? t("common.loading") : confirmLabel || t("common.confirm")}
      cancelLabel={cancelLabel || t("common.cancel")}
      onConfirm={onConfirm}
      onClose={onClose}
      loading={loading}
      tone={variant === "danger" ? "danger" : "accent"}
      isDark={isDark}
    />
  );
};

export default ConfirmModal;
